import React, { Fragment } from 'react'
import { View, Box, Card, Heading, Icon } from '../primitives'
import Feature from '../Feature'
import Favourite from '../Favourite'
import Spinner from '../Spinner'
import styled, { keyframes } from 'styled-components'

const Container = Card.extend.attrs({
	px: [3, 3, 4, 4],
	py: [2, 2, 3, 3],
	boxShadow: 1,
	borderRadius: 0,
	is: "a",
	mb: [3, 3, 4, 4],
})`
	display: flex;
	flex-direction: column;
	position: relative;
	border: 1px solid ${({ theme: { colors } }) => colors.borderColor};
	min-height: 100px;
	overflow: visible;
	&:hover {
		transform: translateY(-5px);
		box-shadow: 0px 25px 20px -20px rgba(0, 0, 0, 0.25);
	}
	&:not(:hover) {
		box-shadow: none;
	}
	transition: all 250ms ease;
	height: 330px;
	&.simple {
		min-height: 150px;
		height: auto;
	}
	@media (max-width: 44.99em) {
		height: auto;
	}
`

const TextNotOnMobile = View.extend`
  position: relative;
  @media (max-width: 44.99em) {
    display: none;
  }
`

const OverflowBox = Box.extend`
  overflow: hidden;
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const Arrow = View.extend`
	background-color: ${({ theme: { colors } }) => colors.primary1Color};
  display: flex;
  align-items: center;
  justify-content: center;
	height: 40px;
	width: 40px;
`

const Center = View.extend.attrs({ color: 'primary2Color' })`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.75);
  opacity: 0;
  animation: ${fadeIn} 1s normal forwards ease-in-out;
  animation-iteration-count: 1;
  animation-delay: 1333ms;
`

const CenterSpinner = () => (
    <Center>
        <Spinner
            color={'currentColor'}
            spinDuration={0.9}
            spinnerWidth="2px"
            size="32px"
        />
    </Center>
)

const Features = View.extend.attrs({
	//px: [0, 0, 4, 4],
//	py: [0, 0, 3, 3],
	mt: [3, 3, 0, 0],
})`
	display: flex;
	justify-content: space-between;

	.left {
		width: calc(100% - 45px);
	}

	.right {
		align-self: flex-end;
	}

  @media (min-width: 45em) {
    position: relative;
    z-index: 1;

    &:after {
      content: ${props => props.simple ? 'normal' : '""'};
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
      height: 138px;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 40%,
        rgba(255, 255, 255, 1) 100%
      );
    }
	}
`

const Highlighted = View.extend`
	position: absolute;
	display: flex;
	justify-content: center;
	width: 40px;
	background-color: ${({ theme: { colors } }) => colors.orange};
	top: -5px;
	right: 16px;
	padding: 10px 0 10px;

	@media (min-width: 720px) {
		right: 32px;
	}

	svg {
		display: block;
	}

	&:after {
		content: "";
		position: absolute;
		bottom: -10px;
		left: 0;
		width: 0px;
		height: 0px;
		border-left: 20px solid transparent;
		border-right: 20px solid transparent;
		border-top: 10px solid ${({ theme: { colors } }) => colors.orange};
	}
`

const Description = View.extend`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`


export default ({
	id,
	title,
	disciplines,
	shortDescription,
	favourites,
	toggleFavourite,
	loading,
	educationLevels,
	// countryCode,
	location,
	// locationRegion,
	locationCountry,
	url,
	highlighted,
  simple
}) => {

  const simpleClass = simple ? 'simple' : ''

  return (
		<Container
			className={`article-grid__news c-link--no-hover ${simpleClass}`}
			href={url || "http://www.renewi.com"}
		>
			{loading ? (
				<CenterSpinner />
			) : (
				<Fragment>
					{toggleFavourite && (
						<Favourite
							onClick={(e) => toggleFavourite(e, id)}
							active={favourites && favourites.includes(id)}
						/>
					)}
					{highlighted && (
						<Highlighted>
							<Icon icon="star" size={26} color="#FFF" />
						</Highlighted>
					)}
					<Box flex="0 0 auto">
						<Heading
							color="secondaryTextColor"
							fontSize={[4, 4, 4, 5]}
							style={{ paddingRight: "50px" }}
							my={1}
						>
							{title || "Analyst Financial Planning"}
						</Heading>
						<Heading color="alternateTextColor" fontSize={2} my={1}>
							{disciplines.join(", ")}
						</Heading>
					</Box>
					{shortDescription && (
						<OverflowBox flex="1 1 auto" overflow="hidden">
							<TextNotOnMobile mb={2} mt={3}>
								<Description
									dangerouslySetInnerHTML={{ __html: shortDescription + "…" }}
								/>
							</TextNotOnMobile>
						</OverflowBox>
					)}
					<Box flex="0 0 auto" mt="auto">
						<Features className={simpleClass} simple={simple}>
							<div className="left">
								<Feature type="location">
									{[location, locationCountry].filter(Boolean).join(", ")}
								</Feature>
								{educationLevels.length ? (
									<Feature type="education">
										{educationLevels.join(", ")}
									</Feature>
								) : null}
							</div>
							<div className="right">
								<Arrow>
									<Icon icon="keyboard-arrow-right" color="#FFF" size={30} />
								</Arrow>
							</div>
						</Features>
					</Box>
				</Fragment>
			)}
		</Container>
	)
}
